export const MOCKED_PLAYERS = [
  {
    displayName: "Vanhouteghem J",
    img:
      "https://lh5.googleusercontent.com/-2uuoiiO5cmE/AAAAAAAAAAI/AAAAAAAAAAA/AKF05nC7QrGTekqgoyNoqEDMUJvT9GFXiw/photo.jpg",
    roles: ["host", "player"],
    uid: "Hxq1Cz22NRcoCZoONpmtjAozV8e2",
    deck: {
      name: "Spiderman - Justice",
      uid: "mocked0",
      content: [
        {
          card: {
            name: "Spider-Man",
            images: {
              front:
                "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01001a.jpg",
              back:
                "https://raw.githubusercontent.com/st4elen/the-vibranium-society/master/MC01en_01001b.jpg"
            },
            metadatas: {
              tags: ["HERO", "SPIDER_MAN"],
              targetName: "SPIDER_MAN"
            }
          },
          counter: 1
        }
      ]
    }
  }
];
